import { HTTPClient } from '../utils/request'

export default {
  get: ({ query }) => HTTPClient.get(`/vehicles${query}`),
  getById: ({ params }) => HTTPClient.get(`/vehicles/${params._id}`),
  create: ({ payload }) => HTTPClient.post(`/vehicles`, payload),
  update: ({ params, payload }) =>
    HTTPClient.put(`/vehicles/${params._id}`, payload),
  switchStatus: ({ params }) =>
    HTTPClient.post(`/vehicles/${params._id}/${params.value}`),
  attachProvider: ({ params, payload }) =>
    HTTPClient.post(`/vehicles/${params.id}/attach`, payload),
  detachProvider: ({ params, payload }) =>
    HTTPClient.post(`/vehicles/${params.id}/detach`, payload),
  trucker: ({ params }) => HTTPClient.post(`/vehicles/${params._id}/active`),
  findVehicleGroup: ({ params }) => HTTPClient.get(`/vehicles/${params._id}/findVehicleGroup`),
  destroy: ({ params, payload }) => HTTPClient.post(`/vehicles/${params._id}/destroy`, payload),
  sendFrota: ({ params }) => HTTPClient.post(`/vehicles/${params._id}/sync-in-fleet`),
}
